/* @flow */
import * as React from 'react';

const ArrowWhiteRight = props => (
  <svg width={16} height={11} viewBox="0 0 16 11" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      fillRule="evenodd"
      d="M0.5,6 L14.237,6 L9.835,10.135 C9.633,10.324 9.624,10.641 9.813,10.842 C9.911,10.947 10.044,11 10.178,11 C10.3,11 10.423,10.955 10.52,10.864 L15.843,5.864 C15.844,5.862 15.845,5.86 15.847,5.858 C15.851,5.854 15.855,5.85 15.858,5.846 C15.861,5.844 15.863,5.844 15.865,5.842 C15.883,5.823 15.889,5.8 15.904,5.78 C15.909,5.772 15.914,5.764 15.919,5.756 C15.931,5.736 15.95,5.719 15.959,5.697 C15.961,5.693 15.961,5.687 15.963,5.683 C15.974,5.654 15.977,5.623 15.982,5.593 C15.987,5.564 15.998,5.536 15.998,5.507 C15.998,5.505 16,5.502 16,5.5 C16,5.497 15.998,5.495 15.998,5.492 C15.998,5.463 15.987,5.435 15.982,5.406 C15.976,5.376 15.974,5.345 15.963,5.316 C15.961,5.311 15.961,5.306 15.959,5.302 C15.95,5.28 15.931,5.263 15.919,5.243 C15.914,5.235 15.908,5.227 15.904,5.219 C15.889,5.199 15.883,5.176 15.865,5.157 C15.863,5.155 15.861,5.155 15.858,5.153 C15.855,5.149 15.851,5.145 15.847,5.142 C15.846,5.14 15.845,5.137 15.843,5.135 L10.52,0.135 C10.319,-0.053 10.004,-0.044 9.813,0.157 C9.624,0.358 9.635,0.675 9.836,0.864 L14.237,5 L0.5,5 C0.224,5 0,5.224 0,5.5 C0,5.776 0.224,6 0.5,6 Z"
    />
  </svg>
);

export default ArrowWhiteRight;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-white-right.js